import { render } from "./StudentTabs.vue?vue&type=template&id=6ec84343"
import script from "./StudentTabs.vue?vue&type=script&lang=js"
export * from "./StudentTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__